import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, verifyOtp } from '../../redux/supportportalLoginSlice';
import './Login.css';
import CustomInput from '../../components/customInput/CustomInput';
import Button from '../../components/button';
import OTPModal from './OTPModal';
import FrontendVersion from './FrontendVersion';

function Login() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [qrImageData, setQrImageData] = useState({
    showQrImage: false,
    qrImageUri: ''
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading: otpLoading, otpError } = useSelector(
    (state) => state.supportportalLogin
  );

  const handleUserIdChange = (e) => {
    setUserId(e.target.value);
    setLoginError('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setLoginError('');
  };

  const handleLogin = () => {
    localStorage.removeItem('access_token');
    const credentials = {
      loginUsername: userId,
      password: password
    };
    dispatch(login(credentials))
      .unwrap()
      .then((response) => {
        if (response.resdata) {
          setQrImageData({
            showQrImage: response.resdata.showQrImage || false,
            qrImageUri: response.resdata.qrImageUri || ''
          });
        }
        setShowOTPModal(true);
      })
      .catch((error) => {
        setLoginError('Username or Password is incorrect');
      });
  };

  const handleOTPVerify = async (otp) => {
    try {
      const response = await dispatch(
        verifyOtp({
          otpToken: otp,
          loginUsername: userId,
        })
      ).unwrap();

      localStorage.setItem('access_token', response.resdata.access_token || '');
      setShowOTPModal(false);
      navigate('/dashboard');
    } catch (error) {
      console.error('OTP error:', error);
      return error;
    }
  };

  const handleShowForgotPasswordPage = () => {
    navigate('/login/forgot-password');
  };

  return (
    <div className="login-body">
      <div style={{ width: '30%' }}>
        <div className='login-text'>Login</div>
        <div className='login-container'>
          <div className="input-label-container">
            <span className="item-label">Username</span>
            <CustomInput
              value={userId}
              onChange={handleUserIdChange}
              style={{ width: '100%' }}
            />
          </div>
          <div className="input-label-container">
            <span className="item-label">Password</span>
            <CustomInput
              type='password'
              value={password}
              onChange={handlePasswordChange}
              style={{ width: '100%' }}
            />
            {loginError && <div style={{ color: 'red', marginTop: '5px' }}>{loginError}</div>}
          </div>
          <div
            className='forgot-password'
            onClick={handleShowForgotPasswordPage}
            style={{ cursor: 'pointer' }}
          >
            Forgot Password?
          </div>
          <Button
            style={{ backgroundColor: '#ED1A3D', color: 'white', width: '100%', height: '40px', borderRadius: '10px', border: 'none', cursor: 'pointer' }}
            onClick={handleLogin}
          >
            LOG IN
          </Button>
        </div>
      </div>

      <OTPModal
        show={showOTPModal}
        onClose={() => setShowOTPModal(false)}
        onVerifySuccess={handleOTPVerify}
        showQrImage={qrImageData.showQrImage}
        qrImageUri={qrImageData.qrImageUri}
        otpLoading={otpLoading}
        otpError={otpError}
      />
      <FrontendVersion />
      <input type="hidden" value="release_202606025" />
    </div>
  );
}

export default Login;